// Central admin detection config
export const ADMIN_EMAILS = [
  'mgxmeta@gmail.com',
  // add more explicit admin emails here if needed
];

export const ADMIN_KEYWORDS = [
  'admin',
  'mgxgold',
  'support',
  'mgxmeta',
];

export function isAdminEmail(email = '') {
  const e = (email || '').toLowerCase().trim();
  if (!e) return false;
  if (ADMIN_EMAILS.some(x => x.toLowerCase() === e)) return true;
  return ADMIN_KEYWORDS.some(k => e.includes(k));
}